import React from 'react'
import { Box, DialogTitle, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface ClosableModalTitleProps {
  title: string
  onClose: () => void
  marginLeft?: string
}

const ClosableModalTitle: React.FC<ClosableModalTitleProps> = ({ title, onClose, marginLeft = '0px' }) => {
  return (
    <DialogTitle>
      <Box sx={{ marginLeft, display: 'inline-flex', alignItems: 'center', width: '100%' }}>
        <IconButton
          onClick={onClose}
          aria-label="close"
          sx={{
            padding: 0,
            marginRight: '6px'
          }}
        >
          <CloseIcon
            sx={{
              fontSize: '2rem',
              color: '#252525'
            }}
          />
        </IconButton>
        {title}
      </Box>
    </DialogTitle>
  )
}

export default ClosableModalTitle
